import React from 'react';

const Brazilian = (props: { width: number }) => {
  return (
    <svg viewBox="-2100 -1470 4200 2940" {...props}>
      <defs>
        <path
          d="M-31.5 0h33a30 30 0 0 0 30-30v-10a30 30 0 0 0-30-30h-33zm13-13h19a19 19 0 0 0 19-19v-6a19 19 0 0 0-19-19h-19z"
          fillRule="evenodd"
          id="brazil_i"
        />
        <path
          d="M0 0h63v-13H12v-18h40v-12H12v-14h48v-13H0z"
          id="brazil_j"
          transform="translate(-31.5)"
        />
        <path
          d="M-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11H25v-12h-51.25z"
          id="brazil_l"
        />
        <g id="brazil_m">
          <clipPath id="brazil_b">
            <path d="M-31.5 0v-70h63V0zM0-47v12h31.5v-12z" />
          </clipPath>
          <use clipPath="url(#brazil_b)" xlinkHref="#brazil_a" />
          <path d="M5-35h26.5v10H5z" />
          <path d="M21.5-35h10V0h-10z" />
        </g>
        <path
          d="M-31.5 0h12v-48l14 48h11l14-48V0h12v-70H14L0-22l-14-48h-17.5z"
          id="brazil_k"
        />
        <path
          d="M0 0a31.5 35 0 0 0 0-70A31.5 35 0 0 0 0 0m0-13a18.5 22 0 0 0 0-44 18.5 22 0 0 0 0 44"
          fillRule="evenodd"
          id="brazil_a"
        />
        <path
          d="M-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z"
          fillRule="evenodd"
          id="brazil_c"
        />
        <g id="brazil_h">
          <use xlinkHref="#brazil_c" />
          <path d="M28 0c0-10 0-32-15-32H-6c22 0 22 22 22 32" />
        </g>
        <path
          d="M-15.75-22C-15.75-15-9-11.5 1-11.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25C-30.5-71-6-70 3-70s26 4 25.75 21.25H13.5c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-.25 11.75 46.25 4 46.25 28.75C31.5-3.5 13.5 0 0 0c-11.5 0-31.55-4.5-31.5-22z"
          id="brazil_n"
        />
        <g fill="#fff" id="brazil_f">
          <g id="brazil_e">
            <path d="M0-1v1h.5" id="brazil_d" transform="rotate(18 0 -1)" />
            <use transform="scale(-1 1)" xlinkHref="#brazil_d" />
          </g>
          <use transform="rotate(72)" xlinkHref="#brazil_e" />
          <use transform="rotate(-72)" xlinkHref="#brazil_e" />
          <use transform="rotate(144)" xlinkHref="#brazil_e" />
          <use transform="rotate(216)" xlinkHref="#brazil_e" />
        </g>
        <use id="brazil_o" transform="scale(31.5)" xlinkHref="#brazil_f" />
        <use id="brazil_p" transform="scale(26.25)" xlinkHref="#brazil_f" />
        <use id="brazil_r" transform="scale(21)" xlinkHref="#brazil_f" />
        <use id="brazil_q" transform="scale(15)" xlinkHref="#brazil_f" />
        <use id="brazil_s" transform="scale(10.5)" xlinkHref="#brazil_f" />
      </defs>
      <rect fill="#009b3a" height="100%" width="100%" x="-50%" y="-50%" />
      <path d="M-1743 0L0 1113 1743 0 0-1113z" fill="#fedf00" />
      <circle fill="#002776" r="735" />
      <clipPath id="brazil_g">
        <circle r="735" />
      </clipPath>
      <path
        clipPath="url(#brazil_g)"
        d="M-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0-3360 0z"
        fill="#fff"
      />
      <g fill="#009b3a" transform="translate(-420 1470)">
        <use transform="rotate(-7)" xlinkHref="#brazil_a" y="-1697.5" />
        <use transform="rotate(-4)" xlinkHref="#brazil_h" y="-1697.5" />
        <use transform="rotate(-1)" xlinkHref="#brazil_i" y="-1697.5" />
        <use transform="rotate(2)" xlinkHref="#brazil_j" y="-1697.5" />
        <use transform="rotate(5)" xlinkHref="#brazil_k" y="-1697.5" />
        <use transform="rotate(9.75)" xlinkHref="#brazil_l" y="-1697.5" />
        <use transform="rotate(14.5)" xlinkHref="#brazil_c" y="-1697.5" />
        <use transform="rotate(17.5)" xlinkHref="#brazil_h" y="-1697.5" />
        <use transform="rotate(20.5)" xlinkHref="#brazil_a" y="-1697.5" />
        <use transform="rotate(23.5)" xlinkHref="#brazil_m" y="-1697.5" />
        <use transform="rotate(26.5)" xlinkHref="#brazil_h" y="-1697.5" />
        <use transform="rotate(29.5)" xlinkHref="#brazil_j" y="-1697.5" />
        <use transform="rotate(32.5)" xlinkHref="#brazil_n" y="-1697.5" />
        <use transform="rotate(35.5)" xlinkHref="#brazil_n" y="-1697.5" />
        <use transform="rotate(38.5)" xlinkHref="#brazil_a" y="-1697.5" />
      </g>
      <use x="-600" xlinkHref="#brazil_o" y="-132" />
      <use x="-535" xlinkHref="#brazil_o" y="177" />
      <use x="-625" xlinkHref="#brazil_p" y="243" />
      <use x="-463" xlinkHref="#brazil_q" y="132" />
      <use x="-382" xlinkHref="#brazil_p" y="250" />
      <use x="-404" xlinkHref="#brazil_r" y="323" />
      <use x="228" xlinkHref="#brazil_o" y="-228" />
      <use x="515" xlinkHref="#brazil_o" y="258" />
      <use x="617" xlinkHref="#brazil_r" y="265" />
      <use x="545" xlinkHref="#brazil_p" y="323" />
      <use x="368" xlinkHref="#brazil_p" y="477" />
      <use x="367" xlinkHref="#brazil_r" y="551" />
      <use x="441" xlinkHref="#brazil_r" y="419" />
      <use x="500" xlinkHref="#brazil_p" y="382" />
      <use x="365" xlinkHref="#brazil_r" y="405" />
      <use x="-280" xlinkHref="#brazil_p" y="30" />
      <use x="200" xlinkHref="#brazil_r" y="-37" />
      <use xlinkHref="#brazil_o" y="330" />
      <use x="85" xlinkHref="#brazil_p" y="184" />
      <use xlinkHref="#brazil_p" y="118" />
      <use x="-74" xlinkHref="#brazil_r" y="184" />
      <use x="-37" xlinkHref="#brazil_q" y="235" />
      <use x="220" xlinkHref="#brazil_p" y="495" />
      <use x="283" xlinkHref="#brazil_r" y="430" />
      <use x="162" xlinkHref="#brazil_r" y="412" />
      <use x="-295" xlinkHref="#brazil_o" y="390" />
      <use xlinkHref="#brazil_s" y="575" />
    </svg>
  );
};

export default Brazilian;
